<template>
  <v-modal
    :id="id"
    :size="size"
  >
    <p
      class="mb-6 text-center"
      v-html="confirmText"
    />
    <div class="d-block btn-group text-center font-0">
      <button
        class="btn btn-outline-gray btn-dialog mb-3 mb-sm-0"
        data-dismiss="modal"
        aria-label="Close"
      >
        {{ cancelBtnText }}
      </button>
      <button
        class="btn btn-dialog btn-default"
        :class="{ disabled: disabledFlg }"
        type="button"
        @click="submitForm"
      >
        <span v-if="requiredIconFlg">
          <i class="material-icons md-white">done</i>
        </span>
        {{ submitBtnText }}
      </button>
    </div>
  </v-modal>
</template>

<script>
import VModal from "../VModal";
import "../../i18n/ja";
import { i18n } from "../../mixins/i18n";
import I18n from "../../i18n/i18n";

export default {
  components: {
    VModal
  },
  mixins: [i18n],
  props: {
    id: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "sm"
    },
    formId: {
      type: String,
      default: "survey-form"
    },
    requiredIconFlg: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: I18n.t("msg.confirm_before_post")
    },
    submitBtnText: {
      type: String,
      default: I18n.t("post")
    },
    cancelBtnText: {
      type: String,
      default: I18n.t("cancel")
    }
  },
  data() {
    return {
      disabledFlg: false
    };
  },
  methods: {
    submitForm() {
      this.disabledFlg = true;
      $(`#${this.formId}`).submit();
    }
  }
};
</script>

<style scoped>
.btn-outline-gray {
  color: #495057 !important;
}
.btn.btn-outline-gray {
  box-shadow: none !important;
}
.material-icons {
  font-size: 21px;
}
</style>
